<template>
  <div>
    <canvas id="salesBudgetExecution" class="w-100 my-auto"></canvas>
    <CElementCover v-show="loading"/>
  </div>
</template>
<script>
  import { Chart, registerables } from 'chart.js'
  import { formatter } from '../../general'
  import CONSTANTS from '../../constants'
  import { dataEjecucionPresupuestoCategorias } from '../../api'

  Chart.register(...registerables)

  export default {
    name: 'SalesBudgetExecutionChart',
    data() {
      return {
        formatter,
        loading: false,
        strInitialPeriod: '',
        strFinalPeriod: '',
        categoriesBudgetExecutionData: []
      }
    },
    props: {
      showTitle: Boolean,
      initialPeriod: String,
      finalPeriod: String,
      idEmployee: String,
      typeMoney: String
    },
    methods: {
      async getCategoriesBudgetExecution(){
        try {
          const { response } = await dataEjecucionPresupuestoCategorias(
            this,
            'R',
            this.initialPeriod,
            this.finalPeriod,
            this.idEmployee,
            this.idCategory
          )

          this.categoriesBudgetExecutionData = response
        } catch (error) {
          console.log(error)          
        }
      },
      labeling({ label, raw }) {
        return `${label} $ ${formatter.format(raw, 0)}`
      },
      setupCategoriesBudgetExecution(){
        const chart = new Chart(
          document.getElementById('salesBudgetExecution'),
          {
            type: 'bar',
            data: {
              labels: this.categoriesBudgetExecutionData.map(data => data.Categoria),
              datasets: [
                {
                  type: 'bar',
                  label: 'Presupuesto',
                  data: this.categoriesBudgetExecutionData.map(data => data.Valor_Presupuesto),
                  fill: false,
                  borderColor: CONSTANTS.colors.color5,
                  backgroundColor: CONSTANTS.colors.color5
                },
                {
                  type: 'bar',
                  label: 'Ventas',
                  data: this.categoriesBudgetExecutionData.map(data => data.Valor_Ventas),
                  borderColor: CONSTANTS.colors.color4,
                  backgroundColor: CONSTANTS.colors.color4
                },
              ]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false, 
              interaction: {
                mode: 'index',
                intersect: false,
              },
              plugins: {
                title: {
                  display: true,
                  text: "Ejecución Presupuesto de Ventas"
                },
                legend: {
                  position: "top"
                }
              }
            }
          }
        )
        chart.options.plugins.tooltip = {
          enabled: true,
          position: 'nearest',
          callbacks: {
            label: this.labeling
          }
        }
        chart.options.scales = {
          y: {
            beginAtZero: true,
            ticks:{
              callback: (value) => {
                return `$ ${formatter.format(value, 0)}`
              }
            }
          }
        }

        chart.update()
      }
    },
    async mounted(){
      this.loading = true

      this.strInitialPeriod = `${this.initialPeriod.substring(0,4)}/${this.initialPeriod.substring(4,7)}`
      this.strFinalPeriod = `${this.finalPeriod.substring(0,4)}/${this.finalPeriod.substring(4,7)}`

      await this.getCategoriesBudgetExecution()
      this.setupCategoriesBudgetExecution()

      this.loading = false
    }
  }
</script>
